import { createContext } from 'react';
import { MenuContextType } from '#baseMenu/contexts';

const MenuContext = createContext<MenuContextType>(null);

export { MenuContext };
